import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'camelCase',
})
export class CamelCasePipe implements PipeTransform {
    transform(value: string | null | undefined): string {
        if (!value) {
            return '';
        }

        // Split camelCase string into words
        // Insert space before uppercase letters and convert to lowercase
        return value
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    }
}
